import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import { ActivityLogResponse } from './def/steps';
import { GlobalVariablesService } from './global-variables.service';

import {
  ContactTypeRequest,
  ContactTypeResponse,
  EquipmentList,
  SaveEquipment
} from './def/contractors';

@Injectable({
  providedIn: 'root'
})
export class ContractorsEquipmentService extends BaseDataService {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  getCEContacts(payload: ContactTypeRequest): Observable<ContactTypeResponse> {
    const url = `${this.serviceBaseUrl}/policy/ce/get-ce-contacts`;
    return this.post<ContactTypeResponse>(url, { body: payload });
  }

  getEquipmentList(payload: ContactTypeRequest): Observable<EquipmentList> {
    const url = `${this.serviceBaseUrl}/policy/ce/get-equipment-list`;
    return this.post<EquipmentList>(url, { body: payload });
  }

  deleteEquipmentForms(payload: ContactTypeRequest): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/ce/delete-ce-contact`;
    return this.post<any>(url, { body: payload });
  }

  saveEquipmentForms(payload: SaveEquipment): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/ce/save-ce-contact`;
    return this.post<any>(url, { body: payload });
  }

  naxt(payload: ContactTypeRequest): Observable<any> {
    const url = `${this.serviceBaseUrl}/policy/ce/ce-contacts-next-step`;
    return this.post<any>(url, { body: payload });
  }
}
